import PropTypes from "prop-types";

/**
 * @typedef {Object} ReferralOverview
 * @property {string|number} [total_referrals]
 * @property {string|number} [total_amount_earned]
 * @property {string|number} [commission_rate]
 * @property {string|number} [converted_referrals]
 * @property {string|number} [total_sales]
 */

/**
 * @typedef {Object} ReferralMetricCardProps
 * @property {React.ReactNode} icon
 * @property {string} [iconLabel]
 * @property {string} title
 * @property {React.ReactNode} [value]
 * @property {string} [bgClass]
 * @property {string} [titleClass]
 * @property {string} [loaderColor]
 * @property {boolean} [isLoading]
 */

export const REFERRAL_METRIC_CARD_PROPS = {
  icon: PropTypes.node.isRequired,
  iconLabel: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.node,
  bgClass: PropTypes.string,
  titleClass: PropTypes.string,
  loaderColor: PropTypes.string,
  isLoading: PropTypes.bool,
};

export const REFERRAL_METRIC_CARD_DEFAULT_PROPS = {
  iconLabel: "",
  value: null,
  bgClass: "",
  titleClass: "",
  loaderColor: "#4E39DF",
  isLoading: false,
};

/**
 * @typedef {Object} ShareReferralsProps
 * @property {string} [link]
 * @property {string} [sharedLink]
 * @property {ReferralOverview|null} [referralOverview]
 * @property {Function} [openModal]
 */

export const SHARE_REFERRALS_PROPS = {
  link: PropTypes.string,
  sharedLink: PropTypes.string,
  referralOverview: PropTypes.object,
  openModal: PropTypes.func,
};

export const SHARE_REFERRALS_DEFAULT_PROPS = {
  link: "",
  sharedLink: "",
  referralOverview: null,
  openModal: () => null,
};
